<section class="w3l-form-25">
  <div class="form-inner-cont">
      <div class="w3l-form-25">
          <h1>Booking (Reservation) Data</h1>
          <p>Enter Booking Data below to stay updated </p>
      </div>
  </div>
</section>

<div id="w3l-appointment">
<section class="appointment-section section-gap">
  <div class="wrapper">

              <form action="#" method="post">
                  <div class="fields-grid">

                    <div class="styled-input">
                      <div class="appointment-form-field" >
                        <label style="width: 10%;">Date</label>
                        <span class="fa fa-calendar" aria-hidden="true"></span>
                        <input type="date" [(ngModel)]="resDate" name="date" id="wdate" required=""  style="width: 30%;" (change)="retriveRes()">
                        <label style="width: 5%;"></label>
                        <label style="width: 10%;">Room Type</label>
                        <span class="fa fa-hotel" aria-hidden="true"></span>
                        <select id="roomtype" required="" name="roomtype"  [(ngModel)]="roomType" [value]="roomType" style="width: 30%;" (change)="retriveRes()" >
                          <option value="">Select*</option>
                          <option value ="Folllow up">Folllow up</option>
                          <option value="Consultation">Consultation</option>
                          <option value="Treatment">Treatment</option>
                          <option value="Follow up Visit">Follow up Visit</option>
                          <option value="Others">Others</option>
                      </select>
                        <label style="width: 5%;"></label>
                        <label style="width: 10%;"> Room </label>
                        <span class="fa fa-hotel" aria-hidden="true"></span>
                          <select id="rooms" name="rooms" style="width: 30%;" required="" [(ngModel)]="roomCode" [value]="roomCode" (change)="retriveRes()" >
                            <option value="">Select *</option>
                            <option value="{{unit.roomCode}}" *ngFor="let unit of roomsList; let i = index">{{unit.roomName}}</option>
                        </select>
                      </div>

                    </div>

                <!------- Doctors ----------->
                <div class="styled-input">
                  <div class="appointment-form-field">
                    <label style="width: 10%;">Doctor</label>
                    <span class="fa fa-search" aria-hidden="true" style="cursor: grab;"  ></span>
                      <select id="doctor" name="doctor" required="" [(ngModel)]="docCode" [value]="docCode" style="width: 30%;" (change)="retriveRes()">
                        <option value="">Select *</option>
                        <option value="{{doc.docCode}}"  *ngFor="let doc of doctorsList; let i = index">{{doc.docName}}</option>
                    </select>
                    <label style="width: 5%;"></label>
                    <label style="width: 10%;">Type</label>
                        <span class="	fa fa-sitemap" aria-hidden="true" ></span>
                        <select id="department" required="" name="type" [(ngModel)]="resType" style="width: 30%;" (change)="retriveRes()" >
                          <option value="">Select*</option>
                          <option value="Consultation">Consultation</option>
                          <option value="Visit">Visit</option>
                          <option value="Treatment">Treatment</option>
                          <option value="Others">Others</option>
                      </select>
                    <label style="width: 5%;"></label>
                    <label style="width: 10%;">Status</label>
                        <span class="fa fa-street-view" aria-hidden="true"></span>
                        <select id="department" style="width: 30%;" required="" name="ststus"  [(ngModel)]="resStatus"  (change)="retriveRes()" >
                          <option value="">Select *</option>
                          <option value="Reservation">Reservation</option>
                          <option value="Attend">Attend</option>
                          <option value="Now">Now</option>
                          <option value="Done">Done</option>
                          <option value="Others">Others</option>
                      </select>
                    </div>
                </div>
                </div>
            <table>
                <thead>
                    <tr>
                        <th style="background-color:  rgb(78, 150, 245);color: white;width: 50px;text-align: center;">Patient ID</th>
                        <th style="background-color:  rgb(78, 150, 245);color: white;width: 110px;text-align: center;">Patient</th>
                        <th style="background-color:  rgb(78, 150, 245);color: white;width: 50px;text-align: center;">Time</th>
                        <th style="background-color:  rgb(78, 150, 245);color: white;width: 50px;text-align: center;">To</th>
                        <th style="background-color:  rgb(78, 150, 245);color: white;width: 100px;text-align: center;">Doctor</th>
                        <th style="background-color:  rgb(78, 150, 245);color: white;width: 80px;text-align: center;">Room Type</th>
                        <th style="background-color:  rgb(78, 150, 245);color: white;width: 110px;text-align: center;">Room</th>
                        <th style="background-color:  rgb(78, 150, 245);color: white;width: 40px;text-align: center;">P.O.</th>
                        <th style="background-color:  rgb(78, 150, 245);color: white;width: 60px;text-align: center;">Select</th>
                        <th style="background-color:  rgb(78, 150, 245);color: white;width: 40px;text-align: center;">Att.</th>

                      </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let res of reservationList; let i = index" >
                      <td data-column="Patient ID" (click)="ProgStep(res)">{{res.patientcode}}</td>
                      <td data-column="Patient Name">{{res.patientname}}</td>
                      <td  data-column="Reservation Time" style="text-align: center;">{{res.restime}}</td>
                      <td data-column="To Time" style="text-align: center;">{{res.restotime}}</td>
                      <td data-column="Doctor Name">{{res.resdocname}}</td>
                      <td data-column="Doctor code">{{res.roomtype}}</td>
                      <td data-column="Doctorse">{{res.roomname}}</td>
                      <td data-column="Status"  style="text-align: center;font-weight: bold;">{{res.docnumber}}</td>
                      <td data-column="Select"><a href="PreparationOrder" class="drop-text" > <button type="button"  name="New" style="border-radius: 10%;width: 100%;height: 30px;" [ngStyle]="{'background-color':  stylebackColor[i],'color':  styleColor[i]}" (click)="OpenPreparation(res)">{{res.resstatus}}</button></a></td>
                      <td data-column="Select"><a href="PatientDocuments" class="drop-text" target="_blank"> <button type="button"  name="Attachments" class="fa fa-paperclip" style="border-radius: 10%;width: 100%;height: 30px;"  (click)="OpenPreparation(res)"></button></a></td>
                      
                    </tr>


                </tbody>

            </table>
              </form>

      </div>

</section>

</div>





